<template>
  <div class="row">
    <div class="col-xs-12">
      <h1 class="page-header">{{ title }}</h1>
      <div class="row">
        <div class="col-xs-12">
          <div class="row">
            <div class="col-xs-12 col-sm-5">
              <div class="form-group">
                <label class="custom-font">Mês de Referência</label>
                <div class="custom-select">
                  <v-select
                    v-model="params.referencia"
                    @input="loadScales"
                    :options="referencias"
                    :reduce="option => option.value"
                    :selectOnTab="true"
                  />
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-3">
              <div class="form-group">
                <label class="custom-font">Status</label>
                <div class="custom-select">
                  <v-select
                    v-model="params.status"
                    @input="loadScales"
                    :options="status"
                    :reduce="option => option.value"
                    :selectOnTab="true"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12">
          <data-table
            ref="escalas"
            title="lista de dados"
            :has-auth="false"
            :api-mode="false"
            :dados="scales"
            :show-empty="true"
            :fields="datatable.columns"
            :carregando="loadingScales"
            :per_page="20"
          >
          </data-table>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

.custom-font {
  font-size: 16px;
  color: #00615c;
}

.custom-select {
  border: 1px solid;
  border-radius: 4px;
  border-color: #00615c;
}

</style>

<script>
import { request } from '@/request'
import DataTable from '@/components/common/NoApiTable'

export default {
  data() {
    return {
      title: 'Relatório de status de escalas',
      params: {
        referencia: null,
        status: 'Todos'
      },
      referencias: [],
      status: [],
      scales: [],
      loadingScales: false,
      datatable: {
        columnID: 'id',
        columns: [
          {
            name: 'uor_label',
            title: 'Unidade',
            dataClass: 'align-middle',
            filterable: true
          },
          {
            name: 'status',
            title: 'Status',
            dataClass: 'align-middle',
            filterable: false
          },
          {
            name: 'data_publicacao',
            title: 'Data de Publicação',
            titleClass: 'text-center',
            dataClass: 'text-center',
            filterable: false
          }
        ]
      }
    }
  },
  components: {
    DataTable
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  created() {
    this.loadReferencias()
    this.loadStatus()

    this.setReferencia()
  },
  mounted() {
    this.loadScales()
  },
  methods: {
    loadReferencias() {
      const currentYear = new Date().getFullYear()
      for (let index = 0; index < 12; index++) {
        const date = new Date(currentYear, index, 1, 1)
        const month = date.toLocaleDateString('pt-BR', { month: '2-digit' })

        const label = date.toLocaleDateString('pt-BR', {
          month: 'long',
          year: 'numeric'
        })
        const value = `${date.getFullYear()}${month}`

        this.referencias.push({
          label,
          value
        })
      }
    },
    loadStatus() {
      const labels = ['Todos', 'Sem registro', 'Pendente', 'Em análise', 'Publicado']
      labels.forEach(item => this.status.push({ label: item, value: item }))
    },
    setReferencia() {
      const currentDate = new Date()
      const date = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + 1,
        1,
        1
      )
      const month = date.toLocaleDateString('pt-BR', {
        month: '2-digit'
      })
      this.params.referencia = `${date.getFullYear()}${month}`
    },
    loadScales() {
      if (this.params.referencia == null) this.setReferencia()
      if (this.params.status == null) this.params.status = 'Todos'

      const { referencia, status } = this.params

      this.loadingScales = true

      const url = `escala/listar-status?referencia=${referencia}&status=${status}`

      request
        .get(url)
        .then(response => (this.scales = response.data))
        .catch(error => console.log(error))
        .then(() => (this.loadingScales = false))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/escalas/Relatorio.vue